import { clsx } from 'clsx';

import { useTitleOfCustom } from './hooks';

import makeClasses from './TitleOfCustom.style';

import type { CustomizationId } from 'shared/domain';
import type { FullMenuCatalog } from 'features/menu-page/domain';

export function TitleOfCustom(props: Props) {
  const { customId, catalog } = props;

  const {
    lang,
    showNames,
    showRestNames,
    restNamesLength,
    description,
    names,
    restNames,
  } = useTitleOfCustom({ customId, catalog });

  const _classes = makeClasses();

  return (
    <>
      <p className={clsx(showNames && _classes.description)}>{description}</p>
      {showNames && (
        <details className={_classes.details}>
          <summary>
            {`${lang.paragraph.second.label} ${names}`}
            {showRestNames && <span>, ...(+{restNamesLength})</span>}
          </summary>
          {showRestNames && restNames}
        </details>
      )}
    </>
  );
}

interface Props {
  customId: CustomizationId;
  catalog: FullMenuCatalog;
}
